const DEFAULT_VALID_STATE_NOTIFICATION = Object.freeze({
    showInfo: false,
    keepInfoOpen: false,
    infoMessageDescriptor: null
});

const DEFAULT_INCOMPLETE_STATE_NOTIFICATION = Object.freeze({
    showInfo: false,
    infoMessageDescriptor: null
});

const resolveValidation = (context, policy) => {
    const stage = policy.getStage(context);
    const complete = policy.isComplete(context);

    const enrichedContext = { ...context, stage, complete };

    const notifyDecision = policy.shouldNotify(enrichedContext);
    const extentMessageDescriptor = policy.getExtentMessageDescriptor(enrichedContext);

    const shouldNotify = typeof notifyDecision === 'object'
        ? Boolean(notifyDecision?.shouldNotify)
        : Boolean(notifyDecision);

    const policyContext = {
        ...context,
        stage,
        complete,
        notify: notifyDecision,
        extentMessageDescriptor
    };

    const shouldSkipExtent = typeof policy.shouldSkipExtentCheck === 'function'
        ? policy.shouldSkipExtentCheck(policyContext)
        : false;

    const shouldValidateGeometry = typeof policy.shouldValidateGeometry === 'function'
        ? policy.shouldValidateGeometry(policyContext)
        : Boolean(complete);

    const shouldValidateExtent = !shouldSkipExtent;

    const stateNotification = complete
        ? (typeof policy.getValidStateNotification === 'function'
            ? policy.getValidStateNotification(policyContext)
            : DEFAULT_VALID_STATE_NOTIFICATION)
        : (typeof policy.getIncompleteStateNotification === 'function'
            ? policy.getIncompleteStateNotification(policyContext)
            : DEFAULT_INCOMPLETE_STATE_NOTIFICATION);

    return {
        stage,
        complete,
        notify: notifyDecision,
        extentMessageDescriptor,
        policyContext,
        shouldValidateGeometry,
        shouldValidateExtent,
        shouldNotify,
        stateNotification
    };
};

export default resolveValidation;
